/*
 * @Author: lishuai lish@zhiding.com.cn
 * @Date: 2024-02-05 17:06:38
 * @LastEditors: lishuai lish@zhiding.com.cn
 * @LastEditTime: 2024-04-26 15:21:03
 * @FilePath: \ai-manage-fe\src\router\index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    // 重定向到登录界面，仅承担后台管理这一个任务
    { path: '/', redirect: '/admin/login' },

    // 登录部分
    { path: '/admin/login', name: 'adminLogin', component: () => import('@/views/login/adminLogin.vue'), meta: { title: '后台管理系统' } },
    { path: '/auth/admin/login', name: 'authAdminLogin', component: () => import('@/views/login/authAdminLogin.vue'), meta: { title: '后台管理系统' } },

    // manage 后台管理
    { path: '/manage/projectList', name: 'manageProjectList', component: () => import('@/views/manage/project/manageProjectList.vue'), meta: { title: '项目列表' } },
    { path: '/manage/createProject', name: 'manageCreateProject', component: () => import('@/views/manage/project/manageCreateProject.vue'), meta: { title: '新建项目' } },
    { path: '/manage/updateProject', name: 'updateProject', component: () => import('@/views/manage/project/updateProject.vue'), meta: { title: '修改项目' } },
    { path: '/manage/updateProjectWithEnter', name: 'updateProjectWithEnter', component: () => import('@/views/manage/project/updateProjectWithEnter.vue'), meta: { title: '修改项目' } },

    // 后台企业部分
    { path: '/manage/enterpriseList', name: 'enterpriseList', component: () => import('@/views/manage/enterprise/enterpriseList.vue'), meta: { title: '企业列表' } },
    { path: '/manage/addEnterprise', name: 'addEnterprise', component: () => import('@/views/manage/enterprise/addEnterprise.vue'), meta: { title: '新建企业' } },
    { path: '/manage/editEnterprise', name: 'editEnterprise', component: () => import('@/views/manage/enterprise/editEnterprise.vue'), meta: { title: '编辑企业' } },

    // 后台人员部分
    { path: '/manage/personList', name: 'personList', component: () => import('@/views/manage/person/personList.vue'), meta: { title: '人员列表' } },
    { path: '/manage/addPerson', name: 'addPerson', component: () => import('@/views/manage/person/addPerson.vue'), meta: { title: '添加人员' } },
    { path: '/manage/editPerson', name: 'editPerson', component: () => import('@/views/manage/person/editPerson.vue'), meta: { title: '编辑人员' } },
    { path: '/manage/patchAddPerson', name: 'patchAddPerson', component: () => import('@/views/manage/person/patchAddPerson.vue'), meta: { title: '添加人员' } },
    { path: '/manage/patchUploadPerson', name: 'patchUploadPerson', component: () => import('@/views/manage/person/patchUploadPerson.vue'), meta: { title: '添加人员' } },
    { path: '/manage/historyList', name: 'historyList', component: () => import('@/views/manage/person/history/historyList.vue'), meta: { title: '演练场景记录' } },
    { path: '/manage/roundList', name: 'roundList', component: () => import('@/views/manage/person/history/roundList.vue'), meta: { title: '演练场景详情' } },

    // 管理员部分
    { path: '/enterManager/managerList', name: 'managerList', component: () => import('@/views/manage/enterManager/managerList.vue'), meta: { title: '管理员列表' } },
    { path: '/enterManager/addManager', name: 'addManager', component: () => import('@/views/manage/enterManager/addManager.vue'), meta: { title: '管理员列表' } },
    { path: '/enterManager/editManager', name: 'editManager', component: () => import('@/views/manage/enterManager/editManager.vue'), meta: { title: '管理员列表' } },

    // 链接失效的路由(上传文件时候用)
    { path: '/project/urlNotInUse', name: 'urlNotInUse', component: () => import('@/views/login/urlNotInUse.vue'), meta: { title: '链接已失效' } },

    // 报告的路径
    { path: '/teamReport', name: 'teamReport', component: () => import('@/views/report/teamReport.vue'), meta: { title: '' } },
    { path: '/personalReport', name: 'personalReport', component: () => import('@/views/report/personalReport.vue'), meta: { title: '' } },

    // 下载个人报告的链接
    { path: '/download/resultDownload', name: 'resultDownload', component: () => import('@/views/manage/download/resultDownload.vue'), meta: { title: '报告下载' } },
  ],
})


router.beforeEach((to, from, next) => {
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next()
})

// 解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// 针对 push 方法
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 针对 replace 方法
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export default router
